export default {
    scripts: state => state.scripts,
    activeScript: state => state.activeScript,
    manageScriptDialog: state => state.manageScriptDialog,
    deleteScriptDialog: state => state.deleteScriptDialog
}
